/**
 * Per-book, per-language diagrammatic infographic image registry.
 *
 * Keyed by string book_id → { lang_code → image URL }. The 10 supported
 * language codes match the site-wide infographic pipeline (en, hi, mr,
 * gu, kn, ta, te, ml, bn, pa). A book/lang is considered "covered" ONLY
 * if it has an entry here — the picker inside the overlay is built from
 * these entries, so it grows automatically as new images are uploaded.
 *
 * When a book/lang combination has NO entry, the overlay falls back to
 * the text-card infographic for that language. Never a broken state.
 *
 * The 10 language codes are declared here for readability, but adding
 * a new lang requires ONLY dropping the file in
 * /app/frontend/public/diagrammatic-infographics/ and adding a line
 * below — no other code changes needed.
 */

export const DIAGRAM_LANG_CODES = [
  "en", "hi", "mr", "gu", "kn", "ta", "te", "ml", "bn", "pa",
];

// Public-served image paths (Create-React-App copies /public verbatim
// to the build root, so /diagrammatic-infographics/... works in prod).
export const DIAGRAMMATIC_INFOGRAPHICS = {
  "5": {  // Think and Grow Rich by Napoleon Hill
    en: "/diagrammatic-infographics/5-en.webp",
    hi: "/diagrammatic-infographics/5-hi.webp",
    mr: "/diagrammatic-infographics/5-mr.webp",
    gu: "/diagrammatic-infographics/5-gu.webp",
    bn: "/diagrammatic-infographics/5-bn.webp",
    ta: "/diagrammatic-infographics/5-ta.webp",
    te: "/diagrammatic-infographics/5-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "22": {  // Build, Don't Talk by Raj Shamani
    en: "/diagrammatic-infographics/22-en.webp",
    hi: "/diagrammatic-infographics/22-hi.webp",
    mr: "/diagrammatic-infographics/22-mr.webp",
    gu: "/diagrammatic-infographics/22-gu.webp",
    bn: "/diagrammatic-infographics/22-bn.webp",
    ta: "/diagrammatic-infographics/22-ta.webp",
    te: "/diagrammatic-infographics/22-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "33": {  // Make Your Bed by Admiral William McRaven
    en: "/diagrammatic-infographics/33-en.webp",
    hi: "/diagrammatic-infographics/33-hi.webp",
    mr: "/diagrammatic-infographics/33-mr.webp",
    gu: "/diagrammatic-infographics/33-gu.webp",
    bn: "/diagrammatic-infographics/33-bn.webp",
    ta: "/diagrammatic-infographics/33-ta.webp",
    te: "/diagrammatic-infographics/33-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "15": {  // Who Moved My Cheese? by Dr. Spencer Johnson
    en: "/diagrammatic-infographics/15-en.webp",
    hi: "/diagrammatic-infographics/15-hi.webp",
    mr: "/diagrammatic-infographics/15-mr.webp",
    gu: "/diagrammatic-infographics/15-gu.webp",
    bn: "/diagrammatic-infographics/15-bn.webp",
    ta: "/diagrammatic-infographics/15-ta.webp",
    te: "/diagrammatic-infographics/15-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "20": {  // The 5 AM Club by Robin Sharma
    en: "/diagrammatic-infographics/20-en.webp",
    hi: "/diagrammatic-infographics/20-hi.webp",
    mr: "/diagrammatic-infographics/20-mr.webp",
    gu: "/diagrammatic-infographics/20-gu.webp",
    bn: "/diagrammatic-infographics/20-bn.webp",
    ta: "/diagrammatic-infographics/20-ta.webp",
    te: "/diagrammatic-infographics/20-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "11": {  // The Power of the Subconscious Mind by Joseph Murphy
    en: "/diagrammatic-infographics/11-en.webp",
    hi: "/diagrammatic-infographics/11-hi.webp",
    mr: "/diagrammatic-infographics/11-mr.webp",
    gu: "/diagrammatic-infographics/11-gu.webp",
    bn: "/diagrammatic-infographics/11-bn.webp",
    ta: "/diagrammatic-infographics/11-ta.webp",
    te: "/diagrammatic-infographics/11-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "4": {  // Atomic Habits by James Clear
    en: "/diagrammatic-infographics/4-en.webp",
    hi: "/diagrammatic-infographics/4-hi.webp",
    mr: "/diagrammatic-infographics/4-mr.webp",
    gu: "/diagrammatic-infographics/4-gu.webp",
    bn: "/diagrammatic-infographics/4-bn.webp",
    ta: "/diagrammatic-infographics/4-ta.webp",
    te: "/diagrammatic-infographics/4-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "3": {  // The ONE Thing by Gary Keller
    en: "/diagrammatic-infographics/3-en.webp",
    hi: "/diagrammatic-infographics/3-hi.webp",
    mr: "/diagrammatic-infographics/3-mr.webp",
    gu: "/diagrammatic-infographics/3-gu.webp",
    bn: "/diagrammatic-infographics/3-bn.webp",
    ta: "/diagrammatic-infographics/3-ta.webp",
    te: "/diagrammatic-infographics/3-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "14": {  // Attitude is Everything by Jeff Keller
    en: "/diagrammatic-infographics/14-en.webp",
    hi: "/diagrammatic-infographics/14-hi.webp",
    mr: "/diagrammatic-infographics/14-mr.webp",
    gu: "/diagrammatic-infographics/14-gu.webp",
    bn: "/diagrammatic-infographics/14-bn.webp",
    ta: "/diagrammatic-infographics/14-ta.webp",
    te: "/diagrammatic-infographics/14-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "2": {  // The 10X Rule by Grant Cardone
    en: "/diagrammatic-infographics/2-en.webp",
    hi: "/diagrammatic-infographics/2-hi.webp",
    mr: "/diagrammatic-infographics/2-mr.webp",
    gu: "/diagrammatic-infographics/2-gu.webp",
    bn: "/diagrammatic-infographics/2-bn.webp",
    ta: "/diagrammatic-infographics/2-ta.webp",
    te: "/diagrammatic-infographics/2-te.webp",
    // kn, ml, pa — pending upload; overlay falls back to text-card
  },
  "7": {  // The Psychology of Money by Morgan Housel
    en: "/diagrammatic-infographics/7-en.webp",
    hi: "/diagrammatic-infographics/7-hi.webp",
    mr: "/diagrammatic-infographics/7-mr.webp",
    gu: "/diagrammatic-infographics/7-gu.webp",
    bn: "/diagrammatic-infographics/7-bn.webp",
    ta: "/diagrammatic-infographics/7-ta.webp",
    te: "/diagrammatic-infographics/7-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "10": {  // Ikigai by Héctor García & Francesc Miralles
    en: "/diagrammatic-infographics/10-en.webp",
    hi: "/diagrammatic-infographics/10-hi.webp",
    mr: "/diagrammatic-infographics/10-mr.webp",
    gu: "/diagrammatic-infographics/10-gu.webp",
    bn: "/diagrammatic-infographics/10-bn.webp",
    ta: "/diagrammatic-infographics/10-ta.webp",
    te: "/diagrammatic-infographics/10-te.webp",
    // kn, ml, pa — pending upload; overlay falls back to text-card
  },
  "13": {  // Life's Amazing Secrets by Gaur Gopal Das
    en: "/diagrammatic-infographics/13-en.webp",
    hi: "/diagrammatic-infographics/13-hi.webp",
    mr: "/diagrammatic-infographics/13-mr.webp",
    gu: "/diagrammatic-infographics/13-gu.webp",
    bn: "/diagrammatic-infographics/13-bn.webp",
    ta: "/diagrammatic-infographics/13-ta.webp",
    te: "/diagrammatic-infographics/13-te.webp",
    // kn, ml, pa — pending upload; overlay falls back to text-card
  },
  "16": {  // Eat That Frog! by Brian Tracy
    en: "/diagrammatic-infographics/16-en.webp",
    hi: "/diagrammatic-infographics/16-hi.webp",
    mr: "/diagrammatic-infographics/16-mr.webp",
    gu: "/diagrammatic-infographics/16-gu.webp",
    bn: "/diagrammatic-infographics/16-bn.webp",
    ta: "/diagrammatic-infographics/16-ta.webp",
    te: "/diagrammatic-infographics/16-te.webp",
    // kn, ml, pa — pending upload; overlay falls back to text-card
  },
  "17": {  // The 80/20 Principle by Richard Koch
    en: "/diagrammatic-infographics/17-en.webp",
    hi: "/diagrammatic-infographics/17-hi.webp",
    mr: "/diagrammatic-infographics/17-mr.webp",
    gu: "/diagrammatic-infographics/17-gu.webp",
    bn: "/diagrammatic-infographics/17-bn.webp",
    ta: "/diagrammatic-infographics/17-ta.webp",
    te: "/diagrammatic-infographics/17-te.webp",
    // kn, ml, pa — pending upload; overlay falls back to text-card
  },
  "21": {  // The Almanack of Naval Ravikant by Eric Jorgenson
    en: "/diagrammatic-infographics/21-en.webp",
    hi: "/diagrammatic-infographics/21-hi.webp",
    mr: "/diagrammatic-infographics/21-mr.webp",
    gu: "/diagrammatic-infographics/21-gu.webp",
    bn: "/diagrammatic-infographics/21-bn.webp",
    ta: "/diagrammatic-infographics/21-ta.webp",
    te: "/diagrammatic-infographics/21-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "34": {  // The Artist's Way by Julia Cameron
    en: "/diagrammatic-infographics/34-en.webp",
    hi: "/diagrammatic-infographics/34-hi.webp",
    mr: "/diagrammatic-infographics/34-mr.webp",
    gu: "/diagrammatic-infographics/34-gu.webp",
    bn: "/diagrammatic-infographics/34-bn.webp",
    ta: "/diagrammatic-infographics/34-ta.webp",
    te: "/diagrammatic-infographics/34-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "41": {  // Blue Ocean Strategy by W. Chan Kim & Renée Mauborgne
    en: "/diagrammatic-infographics/41-en.webp",
    hi: "/diagrammatic-infographics/41-hi.webp",
    mr: "/diagrammatic-infographics/41-mr.webp",
    gu: "/diagrammatic-infographics/41-gu.webp",
    bn: "/diagrammatic-infographics/41-bn.webp",
    ta: "/diagrammatic-infographics/41-ta.webp",
    te: "/diagrammatic-infographics/41-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "18": {  // Deep Work by Cal Newport
    en: "/diagrammatic-infographics/18-en-v2.webp",
    hi: "/diagrammatic-infographics/18-hi.webp",
    mr: "/diagrammatic-infographics/18-mr.webp",
    gu: "/diagrammatic-infographics/18-gu.webp",
    bn: "/diagrammatic-infographics/18-bn.webp",
    ta: "/diagrammatic-infographics/18-ta.webp",
    te: "/diagrammatic-infographics/18-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "35": {  // Wise and Otherwise by Sudha Murty
    en: "/diagrammatic-infographics/35-en.webp",
    hi: "/diagrammatic-infographics/35-hi.webp",
    mr: "/diagrammatic-infographics/35-mr.webp",
    gu: "/diagrammatic-infographics/35-gu.webp",
    bn: "/diagrammatic-infographics/35-bn.webp",
    ta: "/diagrammatic-infographics/35-ta.webp",
    te: "/diagrammatic-infographics/35-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
  "31": {  // The Compound Effect by Darren Hardy
    en: "/diagrammatic-infographics/31-en.webp",
    hi: "/diagrammatic-infographics/31-hi.webp",
    mr: "/diagrammatic-infographics/31-mr.webp",
    gu: "/diagrammatic-infographics/31-gu.webp",
    bn: "/diagrammatic-infographics/31-bn.webp",
    ta: "/diagrammatic-infographics/31-ta.webp",
    te: "/diagrammatic-infographics/31-te.webp",
    // kn, ml, pa — not yet; overlay falls back to the text-card infographic.
  },
};

// Human-readable label per lang, used inside the picker chip. The key
// is deliberately short — the picker sits inside a modal and there's
// limited horizontal room across five or more chips.
export const LANG_LABELS = {
  en: "English",
  hi: "हिन्दी",
  mr: "मराठी",
  gu: "ગુજરાતી",
  kn: "ಕನ್ನಡ",
  ta: "தமிழ்",
  te: "తెలుగు",
  ml: "മലയാളം",
  bn: "বাংলা",
  pa: "ਪੰਜਾਬੀ",
};

/** Return the image URL for (bookId, lang), or null if none exists. */
export function getDiagrammaticImage(bookId, lang) {
  const forBook = DIAGRAMMATIC_INFOGRAPHICS[String(bookId)];
  if (!forBook) return null;
  return forBook[lang] || null;
}

/** Return the languages for which THIS book has a diagram image, in the
 *  canonical order defined by DIAGRAM_LANG_CODES. Empty array if none. */
export function getAvailableDiagramLanguages(bookId) {
  const forBook = DIAGRAMMATIC_INFOGRAPHICS[String(bookId)];
  if (!forBook) return [];
  return DIAGRAM_LANG_CODES.filter((l) => forBook[l]);
}
